export function getUniqueReferenceFromUrl(url: string) {
  try {
    const urlParams = new URLSearchParams(new URL(url).search);
    return urlParams.get('uniqueRef') || url;
  }
  catch {
    return url;
  }
}
